import React from 'react';

interface FieldLabelProps {
  children: React.ReactNode;
  htmlFor: string;
}

const FieldLabel = ({ children, htmlFor }: FieldLabelProps) => {
  return (
    <label
      htmlFor={htmlFor}
      className="mb-8 block font-suisse-intl-mono text-overline-sm text-grayscale-gray"
    >
      {children}
    </label>
  );
};

export default FieldLabel;
